import apiClient from './api-client'

export type WebEamTokenResponse = {
  access_token: string
  token_type: string
  expires_in: number
  refresh_token?: string
  scope?: string
  id_token?: string
}

export async function exchangeCodeForToken(payload: {
  code: string
  redirectUri: string
}): Promise<WebEamTokenResponse> {
  const { data } = await apiClient.post<WebEamTokenResponse>('/v1/login', payload, {
    headers: { 'content-type': 'application/json' },
  })
  return data
}
